// extracted by mini-css-extract-plugin
export default {"indicator":"Jl57oJehDJa12WsVHn3H"};